
    (function(){
        if(!window.rammer) {
          window.rammer = null;
          window.theme = window.theme;
          
          window.theme.translations = window.theme.translations || {};
          window.theme.translations.soldOut = "UDSOLGT";
          
          
          window.theme.html = window.theme.html || {};
          window.theme.html.frame_label = `
            <label class="variant__label" for="">
              Vælg ramme
            </label>
          `;
          window.theme.html.only_poster = `<div><input type="radio" name="radio-ramme" checked value="noRamme" id="noRamme" class="imageRadio input-hidden screen-reader-text"><label class="rammeContainer" for="noRamme"><img class="ramme" src="//peleton.dk/cdn/shop/files/kun-plakat.jpg?v=15370025886170529451" alt="Kun plakat" /><span class="rammeInfo">Kun plakat </br> <span class="rammePrice product__price bf" style="visibility: hidden">+0 kr</span></span></label></div>`;
          
          window.theme.html.generateOnlyPoster = function(id) {
            return `
              <div>
                <input type="radio" name="radio-ramme-${id}" checked value="noRamme" id="noRamme-${id}" class="imageRadio input-hidden screen-reader-text">
                <label class="rammeContainer" for="noRamme-${id}">
                <div class="rammeImgWrapper">
                  <img class="ramme" src="//peleton.dk/cdn/shop/files/kun-plakat.jpg?v=15370025886170529451" alt="Kun plakat" />
                </div>  
                  <span class="rammeInfo">Kun plakat </br> 
                    <span class="rammePrice product__price bf" style="visibility: hidden">+0 kr</span>
                  </span>
                </label>
              </div>`;
          }
        }
  
        if(!window.Images) {
          
          window.Images = {
            removeProtocol(path) {
              return path.replace(/http(s)?:/, '');
            },
              getSizedImageUrl(src, size) {
  
              if (size === null) {
                return src;
              }
  
              if (size === 'master') {
                return this.removeProtocol(src);
              }
  
              const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
  
              if (match) {
                const prefix = src.split(match[0]);
                const suffix = match[0];
  
                return this.removeProtocol(`${prefix[0]}_${size}${suffix}`);
              } else {
                return null;
              }
              }
          }
        }
      })();